import React from "react";

export const Section = ({ id, children, className = "", testId }) => (
  <section
    id={id}
    data-testid={testId}
    className={`py-20 sm:py-28 ${className}`}
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8">{children}</div>
  </section>
);

export const Eyebrow = ({ children, color = "#000000" }) => (
  <span className="eyebrow flex items-center gap-2" style={{ color }}>
    <span
      className="inline-block w-6 h-px"
      style={{ background: "currentColor", opacity: 0.5 }}
    />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left" }) => (
  <div
    className={`max-w-3xl mb-14 ${align === "center" ? "mx-auto text-center" : ""}`}
  >
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-[#000000] mt-4">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-5 text-base sm:text-lg text-[#000000]/70 leading-relaxed">
        {subtitle}
      </p>
    )}
  </div>
);

export const Check = ({ children, color = "#34A853" }) => (
  <li className="flex items-start gap-3">
    <span
      className="mt-1 inline-flex items-center justify-center w-5 h-5 rounded-full shrink-0"
      style={{ background: color }}
    >
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
        <path
          d="M5 13l4 4L19 7"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
    <span className="text-[#000000] leading-relaxed">{children}</span>
  </li>
);
